import ValidationType from '../ValidationType';
import { numberIsGreaterThan, numbersAreEqual } from "../../util";

class GreaterThanValue extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      const current = fieldResponse.currentValue;
      const compare = validation.value;
      if (!numberIsGreaterThan(current, compare) || numbersAreEqual(current, compare)) {
        let validation_value = validation.value;
        if (fieldResponse.fieldInstance.field.fieldType.defined_as == "FIELD_DURATION"){
          validation_value = validation.value + " minutes";
        }

        errors.push(this.createValidationError({
          fieldResponse: fieldResponse,
          key: 'ERROR_GREATER_THAN_SPECIFIED_VALUE',
          values: { value: validation_value },
          message: `Value should be greater than ${validation_value}`,
        }));
      }
    }
    return errors;
  }
}

export default GreaterThanValue;
